import React from 'react';
import styled from 'styled-components';
import { Column, Row } from '@lux/components';
import { H1, SubtitleSecondary } from '../Base';
import Spacing from '../Spacing';
import Notification from '../Notification';
import Button from '../Button';

const ErrorPanel = ({
  pageTitle = null,
  errorMessage = null,
  errorNote = null,
  actionButtonText = null,
  onActionClick = () => {
    // void
  },
  ...props
}) => {
  const hasError = errorMessage || errorNote;
  return hasError ? (
    <Row {...props}>
      <Column sm={12} md={8}>
        {pageTitle && (
          <Spacing bottom={3} bottomMd={5}>
            <H1>{pageTitle}</H1>
          </Spacing>
        )}
        <Spacing bottom={5} bottomMd={9}>
          {errorMessage && (
            <Spacing bottom={3} bottomMd={5}>
              <Notification state="danger">{errorMessage}</Notification>
            </Spacing>
          )}
          {errorNote && <StyledSubtitle>{errorNote}</StyledSubtitle>}
        </Spacing>
        {actionButtonText && (
          <Button
            data-testid="error-panel-action-button"
            onClick={onActionClick}
          >
            {actionButtonText}
          </Button>
        )}
      </Column>
    </Row>
  ) : null;
};

const StyledSubtitle = styled(SubtitleSecondary)`
  color: ${p => p.theme.colours.grey_600};
`;

export default ErrorPanel;
